import axios from "axios";
import { getStock } from "@/common/mixins/analytics";
import { sendYMEvent } from "@/common/services/YandexMetrika/YandexMetrika";

export default {
  getCookie: function (name) {
    const matches = document.cookie.match(
      new RegExp(
        "(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)"
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  setCookie: function (name, value, props) {
    props = props || {};

    let exp = props.expires;
    if (!exp) {
      exp = new Date();
      exp.setFullYear(exp.getFullYear() + 10);
    }
    if (typeof exp === "number" && exp) {
      const d = new Date();
      d.setTime(d.getTime() + exp * 1000);
      exp = props.expires = d;
    }

    if (exp && exp.toUTCString) {
      props.expires = exp.toUTCString();
    }
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    value = encodeURIComponent(value);
    let updatedCookie = name + "=" + value;

    for (let propName in props) {
      updatedCookie += "; " + propName;
      const propValue = props[propName];

      if (propValue !== true) {
        updatedCookie += "=" + propValue;
      }
    }

    document.cookie = updatedCookie;
  },

  deleteCookie: function (name) {
    this.setCookie(name, null, { expires: -1 });
  },

  tryGetClientIdFromGa: function (trackingId) {
    if (!window.ga || !window.ga.getAll) {
      return false;
    }

    try {
      let trackers = window.ga.getAll();
      let i, len;
      for (i = 0, len = trackers.length; i < len; i += 1) {
        if (!trackingId || trackers[i].get("trackingId") === trackingId) {
          return trackers[i].get("clientId");
        }
      }
    } catch (e) {
      // TODO: write error handler
    }
    return false;
  },

  getClientId: function (onSuccess, trackingId, onFailure) {
    if (!trackingId) {
      let gaCookie = this.getCookie("_ga"),
        match = false;
      if (gaCookie && (match = gaCookie.match(/^GA1\.2\.(.+$)/))) {
        onSuccess(match[1]);
        return match[1];
      }
    }

    let clientId;
    if ((clientId = this.tryGetClientIdFromGa())) {
      onSuccess(clientId);
      return clientId;
    }

    let cycles = 0;
    const context = this;
    const interval = setInterval(function () {
      if (
        (clientId = context.tryGetClientIdFromGa(trackingId) || cycles++ > 30)
      ) {
        clearInterval(interval);
        if (clientId) {
          onSuccess(clientId);
        } else {
          onFailure && onFailure();
        }
        return;
      }
    }, 100);
  },

  getTestGroup: function (
    testName,
    groups,
    firstEntryAttrs,
    srcDomain,
    onSuccess,
    onFailure
  ) {
    // try to get value from cookie
    const { inGetClientId } = window.frisbuy;

    if (inGetClientId) {
      setTimeout(() => {
        this.getTestGroup(
          testName,
          groups,
          firstEntryAttrs,
          srcDomain,
          onSuccess,
          onFailure
        );
      });

      return;
    } else {
      let testDataStr,
        testData = {};

      window.frisbuy.inGetClientId = true;

      if ((testDataStr = this.getCookie("friSplitTest"))) {
        try {
          testData = JSON.parse(testDataStr);
        } catch (e) {
          testData = {};
        }

        if (testName in testData) {
          window.frisbuy.inGetClientId = false;
          onSuccess(testData[testName], testData[testName + "_attrs"], false);
          return;
        }
      }

      // otherwise - we'll need clientID
      const context = this;
      this.getClientId(
        function (clientId) {
          let apiUrl =
            srcDomain + "/fb/split?test=" + testName + "&client_id=" + clientId;
          if (groups && groups.length > 0) {
            groups.forEach((group) => {
              apiUrl += "&groups[]=" + group;
            });
          }
          if (firstEntryAttrs) {
            apiUrl +=
              "&first_entry_attrs=" + encodeURIComponent(firstEntryAttrs);
          }
          axios
            .get(apiUrl)
            .then((response) => {
              let groupName = response.data.group;
              let groupAttrs = response.data.attributes;
              testData = testData || {};
              groupAttrs = groupAttrs || {};
              testData[testName] = groupName;
              testData[testName + "_attrs"] = groupAttrs;
              context.setCookie("friSplitTest", testData);
              window.frisbuy.inGetClientId = false;
              onSuccess(groupName, groupAttrs, response.data.isFirstEntry);
            })
            .catch((error) => {
              // todo retry
              window.frisbuy.inGetClientId = false;
              console.log("Get group name error", error);
              onFailure && onFailure();
            });
        },
        null,
        onFailure
      );
    }
  },

  setGroupNameInGa(
    splitTestName,
    groupName,
    trackerParamsObject,
    dimensionId,
    customerCode,
    onComplete
  ) {
    const postList = trackerParamsObject.postList;

    if (!postList || postList.length === 0) {
      console.info("Frisbuy gallery is hidden");
      return;
    }

    function getParamsForGA() {
      const { embed_id, sku_id, skug_id, category_id } = trackerParamsObject;

      const params = {
        embed_id,
        sku_id,
        skug_id,
        category_id,
        stock: getStock(postList, embed_id, sku_id),
      };

      return deleteEmptyFields(params);
    }

    if (trackerParamsObject.frisbuyTrackerId) {
      window.frisbuyGa4(
        "event",
        // `Frisbuy_${categoryPostfix}_${customerCode}`,
        `friSplit${splitTestName}_${groupName}`,
        {
          send_to: trackerParamsObject.frisbuyTrackerId,
          ...getParamsForGA(),
        }
      );
    }

    if (trackerParamsObject.clientTrackerId) {
      window.frisbuyGa4(
        "event",
        // `Frisbuy_${categoryPostfix}`,
        `friSplit${splitTestName}_${groupName}`,
        {
          send_to: trackerParamsObject.clientTrackerId,
          ...getParamsForGA(),
        }
      );
    }
    onComplete();

    function deleteEmptyFields(object) {
      for (const field in object) {
        if (
          !object[field] &&
          typeof object[field] !== "number" &&
          typeof object[field] !== "boolean"
        ) {
          delete object[field];
        }
      }

      return object;
    }
  },

  sendYMSplitTestEvent(
    counterId,
    splitTestName,
    groupName,
    trackerParamsObject,
    onComplete
  ) {
    const action = `Split${splitTestName}_${groupName}`;
    const params = trackerParamsObject;
    /*
      TODO: write handler on "stock" param if it need
      if (getStock(embed_id, sku_id)) {
        Object.assign(params, { stock: getStock(embed_id, sku_id) });
      }
    */

    sendYMEvent(counterId, action, params);

    onComplete();
  },
};
